

const item = ({ userAvatarUrl, userName }) => {
  return `
        <div class="contributore-flex-container">
        <div class="contributores-avatar-holder">
          <div class="contributore-avatar">
            <img src="${userAvatarUrl}" alt="avatar">
          </div>
        </div>
          <div class="contributore-name">
            <span>${userName}</span>
          </div>
          <div class="">
            <div class="buttn primary" data-lang="invite-text">Invite</div>
          </div>
      </div>
`}

export class ChairInvite {
  constructor({ model, socket }) {
    this.model = model;
    this.socket = socket;
    this.wrapper = $(".chair_invite_modal");
    this.list = this.wrapper.find("#chair_invite_list");
    this.input = this.wrapper.find("#chair_invite_input");
  }

  show() {
    const filterUsers = () => {
      const filteredUsers = this.socket.getUsers().filter(item => item.userId !== this.model.config.userId);
      this.list.empty();
      filteredUsers.forEach(user => {
        const _item = $(item(user));
        this.list.append(_item);
        _item.find(".buttn").on("click", () => {
          this.model.onInviteToChair(({ ...user, obj_id: this.parent.dbConfig.id }));
          this.hide();
          this.model.info('success', `Invitation sent`);
        });
      });
    };

    this.input.on('input', filterUsers);

    this.wrapper.addClass("is-active");
    filterUsers(); // Call initially to populate with all users
  }
  hide() {
    this.wrapper.removeClass("is-active");
  }
}